import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const CTA = ({ onContactClick }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const handlePricingClick = (e) => {
    e.preventDefault();
    if (location.pathname === '/') {
      // Ana sayfadaysak direkt scroll yap
      const element = document.getElementById('pricing');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Başka bir sayfadaysak önce ana sayfaya git, sonra scroll yap
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById('pricing');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="section-spacing bg-white">
      <div className="container-custom px-4 sm:px-6">
        <div className={`relative bg-primary rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-16 overflow-hidden transition-all duration-700 ${
          isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
        }`}>
          {/* Background Decorations */}
          <div className={`absolute top-0 right-0 w-48 h-48 sm:w-64 sm:h-64 bg-primary-light/20 rounded-full blur-3xl transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-20'
          }`} style={{ transitionDelay: '200ms' }} />
          <div className={`absolute bottom-0 left-0 w-36 h-36 sm:w-48 sm:h-48 bg-accent-teal/20 rounded-full blur-3xl transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-20'
          }`} style={{ transitionDelay: '300ms' }} />
          
          <div className="relative z-10 text-center max-w-3xl mx-auto">
            <h2 className={`hero-headline text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-white mb-4 sm:mb-6 transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`} style={{ transitionDelay: '100ms' }}>
              {t('cta.headline1')}
              <br />
              <span className="text-accent-teal">{t('cta.headline2')}</span> {t('cta.headline3')}
            </h2>
            
            <p className={`text-base sm:text-lg text-white/80 mb-6 sm:mb-8 md:mb-10 max-w-xl mx-auto transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`} style={{ transitionDelay: '250ms' }}>
              {t('cta.subtitle')}
            </p>
            
            <div className={`flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`} style={{ transitionDelay: '400ms' }}>
              <button 
                onClick={handlePricingClick}
                className="btn-primary text-base sm:text-lg px-6 sm:px-8 py-3 sm:py-4 group hover:scale-105 transition-transform duration-300 w-full sm:w-auto touch-manipulation"
              >
                {t('cta.button')}
                <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" />
              </button>
              <Link 
                to="/iletisim"
                className="text-sm sm:text-base text-white/80 hover:text-white font-medium transition-colors touch-manipulation"
              >
                {t('cta.orContact')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
